import React from 'react';
export function ObjectivesSection() {
  return <section className="py-12 bg-rose-50" data-id="element-56">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 text-center max-w-3xl" data-id="element-57">
        <h2 className="text-3xl md:text-4xl font-bold text-warm-900 mb-8" data-id="element-58">
          El objetivo real{' '}
          <span className="text-rose-600 text-2xl block mt-2 font-serif italic" data-id="element-59">
            (no es que renuncies mañana)
          </span>
        </h2>

        <p className="text-lg text-warm-700 mb-10 leading-relaxed" data-id="element-60">
          No te voy a mentir diciendo que renunciarás en 30 días. El objetivo es
          que tengas tu <strong data-id="element-61">primer ingreso extra validado</strong>.
        </p>

        <div className="bg-white p-8 rounded-2xl shadow-sm border border-rose-100 transform hover:scale-105 transition-transform duration-300" data-id="element-62">
          <p className="text-xl md:text-2xl font-serif text-warm-800 mb-4" data-id="element-63">
            "Ese primer pago, aunque sean $500 o $800 pesos, cambia algo adentro
            de ti."
          </p>
          <div className="w-16 h-1 bg-rose-400 mx-auto rounded-full" data-id="element-64"></div>
          <p className="mt-4 text-warm-600" data-id="element-65">
            Rompes la creencia de "eso no es para mí" y dejas de ver internet
            solo como distracción.
          </p>
        </div>
      </div>
    </section>;
}